import { combineReducers } from 'redux'

import authentication from './authentication'

export const reducer = combineReducers({
  authentication: authentication.reducer,
})

export default reducer
